import { render, staticRenderFns } from "./widget-form.vue?vue&type=template&id=4b2b3309&scoped=true"
import script from "./widget-form.vue?vue&type=script&lang=js"
export * from "./widget-form.vue?vue&type=script&lang=js"
import style0 from "./widget-form.vue?vue&type=style&index=0&id=4b2b3309&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b3309",
  null
  
)

export default component.exports